<script lang="ts">
  export let className: string
</script>

<svg
  class={className}
  stroke="currentColor"
  fill="none"
  stroke-width="2"
  viewBox="0 0 24 24"
  stroke-linecap="round"
  stroke-linejoin="round"
  height="1em"
  width="1em"
  xmlns="http://www.w3.org/2000/svg"
  ><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path
    d="M22 7.535v9.465a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-9.465l9.445 6.297l.116 .066a1 1 0 0 0 .878 0l.116 -.066l9.445 -6.297z"
    stroke-width="0"
    fill="currentColor"
  ></path><path
    d="M19 4c1.08 0 2.027 .57 2.555 1.427l-9.555 6.37l-9.555 -6.37a2.999 2.999 0 0 1 2.354 -1.42l.201 -.007h14z"
    stroke-width="0"
    fill="currentColor"
  ></path></svg
>
